import { transformToCdnUrl } from 'utils/google-storage-util';
import base from './tile-art.module.css';
import styles from './IntegrationDesignTileArt.module.css';

export const IntegrationDesignTileArt: React.FC = () => (
    <img
        className={`${base.layer} ${styles.scene}`}
        src={transformToCdnUrl('embedded-assets/tiles/integration-design-tile.webp')}
        width={1247}
        height={990}
        alt=""
        aria-hidden="true"
        loading="lazy"
    />
);
